import React from 'react';
import RolloutStatusBadge from './RolloutStatusBadge';
import { modeLabelMap } from '../lib/recoveryRolloutFormatters';

const RecoveryRollbackRecommendationPanel = ({ recommendation }) => {
  const shouldRollback = Boolean(recommendation?.shouldRollback);

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-sm font-semibold text-slate-100">Rekomendasi Rollback</h3>
        <RolloutStatusBadge status={shouldRollback ? 'ROLLBACK_RECOMMENDED' : 'READY'} />
      </div>

      <div className="mt-3 space-y-2 rounded-lg border border-slate-800 bg-slate-950/70 p-3">
        <p className="text-xs text-slate-300">
          {shouldRollback
            ? `Rollback ke ${modeLabelMap[recommendation?.recommendedMode] || recommendation?.recommendedMode} direkomendasikan.`
            : 'Tidak ada rollback yang direkomendasikan saat ini.'}
        </p>
        <p className="text-xs text-slate-400">Reason: {recommendation?.reason || '-'}</p>
        <p className="text-xs text-slate-500">Urgency: {recommendation?.urgency || 'LOW'}</p>
      </div>
    </section>
  );
};

export default RecoveryRollbackRecommendationPanel;
